import { Autocomplete, Text } from '@hopskipdrive/react-components';
import { MenuItem } from '@mui/material';
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';

export const StyledAutocomplete = styled(Autocomplete)`
  && {
    .MuiInputBase-root {
      flex-wrap: nowrap;
      max-height: none;
    }
  }
` as typeof Autocomplete;

export const StyledIncidentPriority = styled(Text)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 27px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;

  &.menu {
    margin-right: 8px;
  }

  &.p0 {
    color: ${colorTokens.text.contrast};
    background-color: ${colorTokens.incident.severe};
  }

  &.p1,
  &.p2,
  &.p3 {
    border: 1px solid;
  }

  &.p1 {
    background-color: ${colorTokens.incident.high};
    border-color: ${colorTokens.incident.highBorder};
  }
  &.p2 {
    background-color: ${colorTokens.incident.mid};
    border-color: ${colorTokens.incident.midBorder};
  }
  &.p3 {
    background-color: ${colorTokens.incident.low};
    border-color: ${colorTokens.incident.lowBorder};
  }
`;

export const StyledIncidentClassification = styled.span`
  padding: 2px 4px;
  background-color: ${colorTokens.chip.light};
  border: 1px solid ${colorTokens.chip.border};
  border-radius: 4px;
  text-wrap: wrap;
  color: ${colorTokens.primary.main};
  font-weight: 500;
`;

export const IncidentItem = styled(MenuItem)`
  && {
    padding: 4px 12px;
    align-items: flex-start;

    &:hover {
      background-color: ${colorTokens.primary.hover}!important;
    }

    &[aria-selected='true'],
    &.selected {
      background-color: ${colorTokens.primary.selected};
    }
  }
`;
